(function () {'use strict';}());

angular.module('elidb')
  .controller('AccessibilityController', function ($scope,$timeout,$filter,$window,$document,ELIService) {
  	var trace = angular.trace;

  	$scope.$watch("currentPage",onPageChange);
  	$scope.$watch("surveyRendered",onSurveyRendered);
  	$scope.$watch("showTutorial",onShowTutorial);

  	$document.on("keyup",onKeyup);
 	
 	$scope.focusMenu = function() {
 		$(".forms").attr("tabindex","-1").focus().scrollTop(0);
 	};

 	$scope.focusResources = function() {
 		$(".results-header").attr("tabindex","-1").focus().scrollTop(0);
 	};

 	$scope.focusAccessibilityInstructions = function() {
 		$(".accessibility-instructions").focus().attr("tabindex","-1");
 	};

 	function onKeyup(e) {
 		if($scope.currentPage !== $scope.REFINE_PAGE || !e.ctrlKey) return;

 		e.preventDefault();
 		e.stopImmediatePropagation();

 		switch(e.keyCode) {
 			case 51:
 				$scope.focusResources();
 			break;
 			case 50:
 				$scope.focusMenu();
 			break;
 			case 49: 
 				$scope.focusAccessibilityInstructions();
 			break;
 			default:
 		}
 	}

 	function onPageChange(value) {
 		if(!value) return;

 		if(!window.$) return setTimeout(function(){ onPageChange(value); }, 500);
 		
 		$timeout(function(){
 			$("section.active").attr("tabindex","-1").focus();
 		},0);
 	}

 	function onSurveyRendered(value) {
 		if(value === true) {
 			$timeout(function(){
 				$("*[tabindex='0'],a,button,input,select,textarea").attr("tabindex","-1").addClass("tabdisabled");
	 			$("#popup-form").find(".tabdisabled,a,button,input,select,textarea").attr("tabindex","0").removeClass("tabdisabled");
	 			$("#popup-form").attr("tabindex","-1").focus();
	 		},0);
 		} else if(value === false) {
 			$(".tabdisabled,a,button,input,select,textarea").attr("tabindex","0").removeClass("tabdisabled");
 			onPageChange(true);
 		}
 	}

 	function onShowTutorial(value) {
 		if(value === true) {
 			$timeout(function(){
 				$("*[tabindex='0'],a,button,input,select,textarea,iframe").attr("tabindex","-1").addClass("tabdisabled");
	 			$("#tutorial-container").find(".tabdisabled,a,button,input,select,textarea").attr("tabindex","0").removeClass("tabdisabled");
	 			$("#tutorial-container").attr("tabindex","-1").focus();
	 		},0);
 		} else if(value === false) {
 			$(".tabdisabled,a,button,input,select,textarea,iframe").attr("tabindex","0").removeClass("tabdisabled");
 			onPageChange(true);
 		}
 	}

 });
